import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';

Sentry.init({
  dsn: 'https://0abc63e185c8bf3b0abef0ffac882d9a@o4511707256717312.ingest.de.sentry.io/4511707265826896',
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/angular/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  },
});

// Swiper custom elements — doar în browser (nu în prerender/SSR)
if (typeof window !== 'undefined') {
  import('swiper/element/bundle').then(({ register }) => register());
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
